import { render } from "./SetupTwoFaAtUserProfile.vue?vue&type=template&id=0c52d5f4&scoped=true"
import script from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"
export * from "./SetupTwoFaAtUserProfile.vue?vue&type=script&lang=js"

import "./SetupTwoFaAtUserProfile.vue?vue&type=style&index=0&id=0c52d5f4&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c52d5f4"]])

export default __exports__